import axios from 'axios';
import { notification } from 'antd';
import { config } from '@/config/index.js';
import i18n from '@/i18n.js';

const { API_BASE_URL } = config;

axios.defaults.withCredentials = true;
// 创建 axios 实例
const request = axios.create({
  baseURL: API_BASE_URL + '/client',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

request.interceptors.request.use(
  config => {
    config.headers['Scams-App-Language'] = i18n.language;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  response => {
    return response.data;
  },
  async error => {
    const { response } = error;
    if (axios.isCancel(error)) {
      return;
    }
    const errorText =
      response?.data?.message ||
      i18n.t(`network:status_${status}`) ||
      i18n.t('network:requestErrorDefaultDescription');
    const errorTitle =
      response?.data?.title ||
      (status
        ? i18n.t('network:requestErrorTitleWithStatus', { status })
        : i18n.t('network:requestErrorDefaultTitle'));
    const status = response?.status;
    notification.error({
      message: errorTitle,
      description: errorText,
    });
    throw error;
  }
);

const enhancedRequest = (url, options) => {
  const { signal, ...restOptions } = options || {};

  // 如果有 signal，且是标准 AbortSignal 对象
  if (signal && signal instanceof AbortSignal) {
    return request(
      url,
      {
        ...restOptions,
        signal,
      },
      { timeout: 60000 }
    );
  }

  // 如果没有 signal，直接发起请求
  return request(url, restOptions);
};

export default enhancedRequest;
